const EMPTY_GUID = '00000000-0000-0000-0000-000000000000'

const DATASET_CODE_ELEMENTS = ['PROJCODE1', 'PROJCODE2']
const DATASET_GUID_ELEMENT = 'PRGUID'
const FIELD_CODE_ELEMENTS = ['PrCode']
const FIELD_GUID_ELEMENT = 'PrGuid'

function stripByteOrderMark(text) {
  return text.charCodeAt(0) === 0xfeff ? text.slice(1) : text
}

function escapeForRegex(value) {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

function escapeXmlText(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
}

function hasRename(projectFile) {
  if (!projectFile || !projectFile.newProjectCode) return false
  return projectFile.newProjectCode !== projectFile.projectCode
}

function replaceCodeElements(content, elementNames, oldCode, newCode) {
  return elementNames.reduce((result, elementName) => {
    const pattern = new RegExp(`<${elementName}>${escapeForRegex(oldCode)}</${elementName}>`, 'g')
    return result.replace(pattern, `<${elementName}>${escapeXmlText(newCode)}</${elementName}>`)
  }, content)
}

function clearGuidElement(content, elementName) {
  const pattern = new RegExp(`<${elementName}>[^<]{0,36}</${elementName}>`, 'g')
  return content.replace(pattern, `<${elementName}>${EMPTY_GUID}</${elementName}>`)
}

function renameInDataset(datasetContent, oldCode, newCode) {
  if (!datasetContent) return datasetContent
  const renamed = replaceCodeElements(datasetContent, DATASET_CODE_ELEMENTS, oldCode, newCode)
  return clearGuidElement(renamed, DATASET_GUID_ELEMENT)
}

function renameInFieldXml(fieldXml, oldCode, newCode) {
  if (!fieldXml) return fieldXml
  const renamed = replaceCodeElements(fieldXml, FIELD_CODE_ELEMENTS, oldCode, newCode)
  return clearGuidElement(renamed, FIELD_GUID_ELEMENT)
}

function removeEmptyFields(input) {
  if (!input || typeof input !== 'object') return

  Object.keys(input).forEach(key => {
    const value = input[key]
    if (value === null || value === '') {
      delete input[key]
      return
    }
    removeEmptyFields(value)
  })
}

function objectToXml(value, elementName) {
  if (Array.isArray(value)) {
    return value.map(item => objectToXml(item, elementName)).join('')
  }

  if (value !== null && typeof value === 'object') {
    const children = Object.keys(value)
      .map(key => objectToXml(value[key], key))
      .join('')
    return `<${elementName}>${children}</${elementName}>`
  }

  return `<${elementName}>${escapeXmlText(value)}</${elementName}>`
}

function fieldJsonToXml(jsonString) {
  const parsed = JSON.parse(stripByteOrderMark(String(jsonString)))

  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
    throw new Error('Field JSON must be an object; this file is not TerraIndex field data.')
  }

  removeEmptyFields(parsed)

  const body = Object.keys(parsed)
    .map(key => objectToXml(parsed[key], key))
    .join('')

  return `<?xml version="1.0" encoding="utf-8"?>${body}`
}

function encodeBase64(text) {
  const utf8 = encodeURIComponent(String(text)).replace(/%([0-9A-F]{2})/gi, (match, hex) =>
    String.fromCharCode(parseInt(hex, 16))
  )
  return btoa(utf8)
}

export default {
  EMPTY_GUID,
  hasRename,
  renameInDataset,
  renameInFieldXml,
  fieldJsonToXml,
  encodeBase64
}
